<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title text-primary">Informações</h3>
    </div>
    <pre>
      {{ emailRawDecoded }}
    </pre>
  </div>
</template>
<script>
export default {
  name: 'AppInfoEmailQualisoftRaw',

  props: {
    emailRawDecoded: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/provider-qualisoft/InfoEmailQualisoftRaw.vue